"use strict";

var _defineProperty = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftAlignButtonWidths = exports.LeftAlignButtonSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var classnames_1 = tslib_1.__importDefault(require("classnames"));

var constants_1 = require("../../../constants");

var styles = tslib_1.__importStar(require("./LeftAlignButton.style"));

exports.LeftAlignButtonSizes = ['large', 'medium'];
exports.LeftAlignButtonWidths = ['fit', 'full'];

function LeftAlignButton(_ref) {
  var className = _ref.className,
      title = _ref.title,
      iconUrl = _ref.iconUrl,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'fit' : _ref$width,
      link = _ref.link,
      disabled = _ref.disabled,
      _ref$disableTapHighli = _ref.disableTapHighlight,
      disableTapHighlight = _ref$disableTapHighli === void 0 ? false : _ref$disableTapHighli;

  function handleLink() {
    window.location.href = "".concat(link || '');
  }

  return jsx_runtime_1.jsxs("button", Object.assign({
    className: classnames_1.default(className, _defineProperty({}, constants_1.TAP_HIGHLIGHT_TRANSPARENT, disableTapHighlight)),
    type: "button",
    css: [styles.wrapper, size && styles.sizeStyles[size], width && styles.widthStyles[width]],
    disabled: disabled,
    onClick: handleLink
  }, {
    children: [jsx_runtime_1.jsx("span", Object.assign({
      css: size && styles.iconWrapper[size]
    }, {
      children: jsx_runtime_1.jsx("img", {
        src: iconUrl,
        alt: iconUrl
      }, void 0)
    }), void 0), jsx_runtime_1.jsx("span", Object.assign({
      css: [size && styles.titleWrapper[size], styles.ellipsis]
    }, {
      children: title
    }), void 0)]
  }), void 0);
}

exports.default = LeftAlignButton;